export const preventCharEnterWithoutZero = {
  methods: {
    /**
     * @description Prevent user to enter "-", "0" as leading zero, "e" and "+" into <input type="number" />
     * @return {boolean}
     */
    MX_preventCharInputWithoutZero (e) {
      if (e.key === "-" || e.key === "+" || e.key === 'e') {
        e.preventDefault();
        return false;
      }
    }
  }
};
